import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import AssessmentActions from 'components/checkIn/questionnaire/AssessmentActions';
import useRedirectToResults from 'components/checkIn/useRedirectToResults';

const PromptToViewResults = () => {
  const viewResults = useRedirectToResults();
  const copy = useCopy();

  return (
    <AssessmentActions blurb={copy.blurb} buttonText={copy.buttonText} onClick={viewResults} />
  );
};
export default PromptToViewResults;

const useCopy = () => {
  const copy = defineMessages({
    alreadySubmittedBlurb: {
      id: 'check-in.already-submitted.blurb',
      defaultMessage: 'Looks like you have already submitted your check in for the day!',
    },
    viewResultsButtonCaption: {
      id: 'check-in.already-submitted.button-caption',
      defaultMessage: 'View Results',
    },
  });

  const intl = useIntl();
  const blurb = intl.formatMessage(copy.alreadySubmittedBlurb);
  const buttonText = intl.formatMessage(copy.viewResultsButtonCaption);

  return { blurb, buttonText };
};
